import React from "react";
import emailjs from 'emailjs-com';
import Helmet from 'react-helmet';
import Box from '@mui/material/Box';
import BottomBox from "./BottomBox";
import { useRef } from "react";
import Pop from './Pop';
import './contact.css';


const Contact = (props) => {
    const {history} = props;
    const form = useRef();
    function sendEmail(e){
        e.preventDefault();

        emailjs.sendForm('service_xe76lre', 'template_r5g5nyo', form.current, 'QKi1HrrT_PkUw1MYU')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset()
    }
        

    return ( 
        <div className="contact-container">
            <Pop btcolor='white'/>
            <Box 
                sx = {theme => ({ [theme.breakpoints.up('sm')]:{backgroundColor:'#202020',width:'100%',height:'50vh',maxHeight:'50%'},
                [theme.breakpoints.between('0','600')]:{backgroundColor:'#202020',width:'100%',height:'35vh',minHeight:'35vh',maxHeight:'50%'}
                })}
            
            />
        
        <p onClick={()=> history.push('/')} className='contact__head'>
          Untouched
        </p>
      
        <div className='contact__heading'>
          <p>Contact</p> 
          </div>
        <div className="contact">
        <Helmet bodyAttributes={{style: 'background-color : white'}}/> 
        {/* <p className="vert-ical">Untouched</p> */}
            
            <div className="l">
                <p className="feel-head">Feel free to get Untouched</p>
                <div className="main-address">
                    <div className="img-address">
                        <img  src="images/contact/pin.png" alt="img" />
                    </div>
                    <div className="sub-address">
                    <div  className='sub-address-head'>Address</div>
                    <div style={{width:'70%',fontSize:'0.75rem',opacity:0.7}}>10-1-128/1/2D, Ali Manor Complex,
                    2nd Floor, Masab Tank,
                    Hyderabad,Telangana 500028</div>

                    </div>
                </div>
                {/* <hr style={{border: 0,height: 0,borderTop: '1px solid rgba(0, 0, 0, 0.1)',borderBottom: '1px solid rgba(255, 255, 255, 0.3)',margin:'2% 4% 0% 0%'}}/> */}
                <div className="main-call">
                    <div className="img-call">
                        <img  src="images/contact/call.png" alt="img" />
                    </div>
                    <div className="sub-call">
                    <div className='sub-call-head'>Call Us</div>
                    <div style={{fontSize:'0.75rem',opacity:0.7}}>+914046038583</div>
                    </div>
                </div>
                {/* <hr style={{border: 0,height: 0,borderTop: '1px solid rgba(0, 0, 0, 0.1)',borderBottom: '1px solid rgba(255, 255, 255, 0.3)',margin:'2% 4% 0% 0%'}}/> */}
                <div className="main-enquiry">
                    <div className="img-enquiry">
                        <img style={{marginRight:'2%'}} src="images/contact/email.png" alt="img" />
                    </div>
                    <div className="sub-enquiry">
                    <div className='sub-enquiry-head'>General Enquiries</div>
                    <div style={{fontSize:'0.75rem',opacity:0.7}}>info@gountouched.in</div>
                    </div>
                </div>

            </div>
            <div className="r">
              <Box  
                     sx = {theme => ({ [theme.breakpoints.up('sm')]:{width:'28rem',height:'32rem',backgroundColor:'#F3F3F3',border:'1px solid #E2E2E2',margin:'-30% 0% 0% -5%'},
                     [theme.breakpoints.between('0','600')]:{width:'100vw',maxWidth:'100%',height:'auto',backgroundColor:'#F3F3F3',border:'1px solid #E2E2E2',margin:'auto'}
                     })}
              
              >
              
                
                <div className="inputbox">
                <p className="ready"><span>Ready to get Started?</span></p>
                <form  ref={form} onSubmit={sendEmail} >
                <div className="inputs">
                <div className="input-small-head">Full Name</div>
                <input required className="same" autoComplete="off"  type="text"  placeholder="Enter your full name" name='name'/><br />
                <p></p>
                <div className="input-small-head">Email</div>
                <input  required  className="same" autoComplete="off" type="email"  placeholder="Enter your email" name='email'/><br />
                <p></p>
                <div className="input-small-head">Subject</div>
                <input required className="same" autoComplete="off" type="text"  placeholder="Enter subject" name='subject'/><br />
                <p></p>
                <div className="input-small-head">Message</div>
                <textarea required className="ur-msg" autoComplete="off" type="textmsg"  placeholder="Type here" name='message'/><br />
                <p></p>
                <input style={{cursor:'pointer'}} type='submit' className="send-bt"  value='Send Message'></input>
                </div>
                </form>
                </div>
                
              </Box>
            </div>
        
         </div>
         <BottomBox/>
         </div>
);
}
 
export default Contact;